import { useEffect, useRef } from "react";
import { Helmet } from "react-helmet-async";
import { Link } from "react-router-dom";
import Typed from "typed.js";
import "../scss/blog.scss";

export default function Blog() {
  const nameExt = " | charlie-gp";
  const pageTitle = "Read a blog";
  const elem = useRef(null);
  const typed = useRef(null);

  // Use typing effect
  useEffect(() => {
    const options = {
      strings: ["......."],
      loop: true,
      typeSpeed: 500,
      fadeOut: true,
      fadeOutClass: "typed-fade-out",
      fadeOutDelay: 500,
      showCursor: false,
      smartBackspace: true,
    };

    typed.current = new Typed(elem.current, options);
  }, []);

  return (
    <div id="blog">
      <Helmet>
        <title>{pageTitle + nameExt}</title>
      </Helmet>

      <h1 id="title">
        {pageTitle}&nbsp;
        <Link to="/">or back home?</Link>
      </h1>

      <div id="posts">
        <div className="post-item">
          <Link to="/blog/merge-local-and-remote-repos-in-git/">
            Merge Local and Remote Repos in Git
          </Link>
        </div>
        <div className="hashtags">
          <span>November 7, 2022</span>
          <span>
            <Link to="/">#git</Link>
          </span>
          <span>
            <Link to="/">#github</Link>
          </span>
        </div>
        <br />
        <div className="post-item">
          <Link to="/blog/unresponsive-single-column-in-bootstrap/">
            Unresponsive Single Column in Bootstrap
          </Link>
        </div>
        <div className="hashtags">
          <span>November 6, 2022</span>
          <span>
            <Link to="/">#bootstrap</Link>
          </span>
          <span>
            <Link to="/">#reactjs</Link>
          </span>
        </div>
        <br />
        <div className="post-item">
          <Link to="/blog/intro-to-devops/">An Intro to DevOps</Link>
        </div>
        <div className="hashtags">
          <span>November 11, 2022</span>
          <span>
            <Link to="/">#Azure</Link>
          </span>
          <span>
            <Link to="/">#DevOps</Link>
          </span>
        </div>
        <br />
        <div className="post-item">
          <Link to="/blog/redirect-page-in-react/">Redirect Page in React</Link>
        </div>
        <div className="hashtags">
          <span>November 12, 2022</span>
          <span>
            <Link to="/">#react</Link>
          </span>
        </div>
        <br />
        <div className="post-item">
          <Link to="/blog/its-never-too-late/">It's Never Too Late</Link>
        </div>
        <div className="hashtags">
          <span>November 13, 2022</span>
          <span>
            <Link to="/">#softwareengineering</Link>
          </span>
        </div>
        <br />
        <p className="fw-bold fs-6">
          <em>
            charlie is typing<span ref={elem}></span>
          </em>
        </p>
      </div>
    </div>
  );
}
